import React, { useEffect, useContext, useMemo } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { MyContext } from '../context/UserProvider';
import { useNavigate } from 'react-router-dom';

const AnimatedText = () => {
  const controls = useAnimation();
  const { scrollY, windowSize } = useContext(MyContext);
  const navigate = useNavigate();

  const BASE_FONT = 200;
  const BASE_WIDTH = 1200;
  const EXPONENT = 2.2; // menos agressivo que 3
  const MIN_RESPONSIVE = 28; // menor para mobile
  const MIN_END_FONT = 20;
  const REDUCTION_FACTOR = 0.7;
  const BASE_HEIGHT = 962;

  const width = (windowSize && windowSize.width) ? windowSize.width : BASE_WIDTH;
  const height = (windowSize && windowSize.height) ? windowSize.height : BASE_HEIGHT;
  const scaleW = width / BASE_WIDTH;
  const scaleH = height / BASE_HEIGHT;
  const combinedScale = Math.sqrt(scaleW * scaleH);

  // memoiza para não recalcular sem necessidade
  const startFontSize = useMemo(() => {
    let s = Math.round(BASE_FONT * Math.pow(combinedScale, EXPONENT) * REDUCTION_FACTOR);
    s = Math.min(BASE_FONT, Math.max(MIN_RESPONSIVE, s));
    return s;
  }, [combinedScale]);

  const endFontSize = Math.max(MIN_END_FONT, Math.round(startFontSize * (30 / 200)));

  useEffect(() => {
    const threshold = 0.01;
    const startY = 0; // scrollY <= threshold = top
    // usamos translateY (y) em vez de top para animação mais suave
    if (scrollY > threshold) {
      controls.start({
        y: 0, // sobe 30px
        fontSize: `${endFontSize}px`,
        transition: { duration: 0.44, ease: 'easeInOut' }
      });
    } else {
      controls.start({
        y: 0,
        fontSize: `${startFontSize}px`,
        transition: { duration: 0.6, ease: 'easeInOut' }
      });
    }
  }, [scrollY, controls, startFontSize, endFontSize]);

  return (
    <motion.div translate="no"
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginTop:  0, // mais espaço no topo para desktop
        // evita que o texto quebre o layout em telas pequenas
        paddingLeft: 12,
        paddingRight: 12,
        boxSizing: 'border-box'
      }}
    >
      <motion.h1
        animate={controls}
        initial={{ fontSize: `${startFontSize}px`, y: 0 }}
        style={{
          fontFamily: '"Playfair Display", serif',
          margin: 0,
          // permite quebra mínima; evita overflow: use maxWidth + ellipsis
          display: 'inline-block',
          maxWidth: '100%', 
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap', // opcional: se realmente quiser só uma linha, mantenha
          color: scrollY <= 0.01 ? '#fff' : '#000',
          letterSpacing: width > 480 ? (scrollY <= 0.01 ? '15px' : '0px') : '1px', // reduz espacemento em mobile
          transition: 'color 0.4s ease, letter-spacing 0.4s ease',
          fontWeight: 'normal',
          cursor: 'pointer',
          textAlign: 'center',
          
          // prevenir seleção acidental em mobile
          WebkitTapHighlightColor: 'transparent',
          touchAction: 'manipulation'
        }}
        onClick={() => {
          // remover item em vez de gravar "null"
          localStorage.removeItem('produto_id');
          navigate('/');
        }}
      >
        Royal Sofás
      </motion.h1>
    </motion.div>
  );
};

export default AnimatedText;
